import React from 'react';
import * as Dati from '../../Dati';
import { CampoNumero, Trad, Tipo } from '../../components';
import { DocumentHocComponent } from '../../components/custom/Document/DocumentHocComponent';
import { IBinderProduct } from '../../form/Binder'

interface IBinderProductProps{
    ApprovalList: Dati.TDictTipo;
    Data: IBinderProduct;
    Editable: boolean;
    OnChange: (e: React.FormEvent<any> | string, valore?: any) => any;
}  

export const BinderProduct: React.FC<IBinderProductProps> = ({ Data, Editable, ApprovalList, OnChange }) => {
    const isProductDisabled = !Data.Checked;
    const index = Data.Index;

    return (
        <div className="tab-pane active" key={index}>
            <div className="row">
                <div className="col-lg-12">
                    <label className="kt-checkbox kt-checkbox--solid kt-checkbox--brand">
                        {Trad.Trad(Data.TipoRamo)} - {Trad.Trad(Data.TipoProdotto)}
                        <input
                            onChange={OnChange}
                            type="checkbox"
                            checked={Data.Checked}
                            name={`Dato.Extra[${index}].Checked`}
                            id={`Dato.Extra[${index}].Checked`}
                        />
                        <span />
                    </label>
                </div>

                <div className="col-lg-4">
                    <label>{Trad.Trad("Limite per singolo contraente")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero
                            Id={`Dato.Extra[${index}].LimitePerSingoloContraente`}
                            Name={`Dato.Extra[${index}].LimitePerSingoloContraente`}
                            Valore={Data.LimitePerSingoloContraente}
                            Massimo={Data.LimitePerSingoloContraenteMAX}
                            OnChange={OnChange}
                            Disabilitato={isProductDisabled}
                            CSS="form-control kt-input"
                            Icona="la la-money"
                            BarraLimiti
                        />
                    </div>
                </div>
                <div className="col-lg-4">
                    <label>{Trad.Trad("Limite per singolo prodotto")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero
                            Id={`Dato.Extra[${index}].LimitePerSingoloProdotto`}
                            Name={`Dato.Extra[${index}].LimitePerSingoloProdotto`}
                            Valore={Data.LimitePerSingoloProdotto}
                            Massimo={(Data.LimitePerSingoloProdottoMAX <= Data.LimitePerSingoloContraente) ? Data.LimitePerSingoloProdottoMAX : Data.LimitePerSingoloContraente}
                            OnChange={OnChange}
                            Disabilitato={isProductDisabled}
                            CSS="form-control kt-input"
                            Icona="la la-money"
                            BarraLimiti
                        />
                    </div>
                </div>
                <div className="col-lg-4">
                    <label>{Trad.Trad("Limite diritti fissi")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero
                            Id={`Dato.Extra[Dato.Extra[${index}]].LimiteDirittiFissi`}
                            Name={`Dato.Extra[${index}].LimiteDirittiFissi`}
                            Valore={Data.LimiteDirittiFissi}
                            Massimo={Data.LimiteDirittiFissiMAX}
                            OnChange={OnChange}
                            Disabilitato={isProductDisabled}
                            CSS="form-control kt-input"
                            Icona="la la-money"
                            BarraLimiti
                        />
                    </div>
                </div>

                <div className="col-lg-4">
                    <label>{Trad.Trad("Limite accessori")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero
                            Id={`Dato.Extra[${index}].LimiteAccessori`}
                            Name={`Dato.Extra[${index}].LimiteAccessori`}
                            Valore={Data.LimiteAccessori}
                            Massimo={Data.LimiteAccessoriMAX}
                            OnChange={OnChange}
                            Disabilitato={isProductDisabled}
                            CSS="form-control kt-input"
                            Icona="fa fa-percentage"
                            BarraLimiti
                        />
                    </div>
                </div>
                <div className="col-lg-4">
                    <label>{Trad.Trad("Limite flessibilita")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero
                            Id={`Dato.Extra[${index}].LimiteFlessibilita`}
                            Name={`Dato.Extra[${index}].LimiteFlessibilita`}
                            Valore={Data.LimiteFlessibilita}
                            Massimo={Data.LimiteFlessibilitaMAX}
                            OnChange={OnChange}
                            Disabilitato={isProductDisabled}
                            CSS="form-control kt-input"
                            Icona="fa fa-percentage"
                            BarraLimiti
                        />
                    </div>
                </div>
                <div className="col-lg-4">
                    <label>{Trad.Trad("Premio minimo")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero
                            Id={`Dato.Extra[${index}].PremioMinimo`}
                            Name={`Dato.Extra[${index}].PremioMinimo`}
                            Valore={Data.PremioMinimo}
                            Minimo={Data.PremioMinimoMAX}
                            ValoreNeutro={0}
                            OnChange={OnChange}
                            Disabilitato={isProductDisabled}
                            CSS="form-control kt-input"
                            Icona="la la-money"
                            BarraLimiti
                        />
                    </div>
                </div>

                <div className="col-lg-4">
                    <label className="kt-checkbox kt-checkbox--solid kt-checkbox--brand">
                        {Trad.Trad("TacitoRinnovo")}
                        <input
                            disabled={isProductDisabled}
                            onChange={OnChange}
                            type="checkbox"
                            checked={Data.TacitoRinnovo}
                            name={`Dato.Extra[${index}].TacitoRinnovo`}
                            id={`Dato.Extra[${index}].TacitoRinnovo`}
                        />
                        <span />
                    </label>
                </div>
                <div className="col-lg-4">
                    <label className="kt-checkbox kt-checkbox--solid kt-checkbox--brand">
                        {Trad.Trad("EmissioneDirettaPOS")}
                        <input
                            disabled={isProductDisabled}
                            onChange={OnChange}
                            type="checkbox"
                            checked={Data.EmissioneDirettaPOS}
                            name={`Dato.Extra[${index}].EmissioneDirettaPOS`}
                            id={`Dato.Extra[${index}].EmissioneDirettaPOS`}
                        />
                        <span />
                    </label>
                </div>
                <div className="col-lg-4">
                    <label className="kt-checkbox kt-checkbox--solid kt-checkbox--brand">
                        {Trad.Trad("EmissioneOrarioUfficio")}
                        <input
                            disabled={isProductDisabled}
                            onChange={OnChange}
                            type="checkbox"
                            checked={Data.EmissioneOrarioUfficio}
                            name={`Dato.Extra[${index}].EmissioneOrarioUfficio`}
                            id={`Dato.Extra[${index}].EmissioneOrarioUfficio`}
                        />
                        <span />
                    </label>
                </div>

                <div className="col-lg-8 offset-lg-2">
                    <DocumentHocComponent
                        Label={Trad.Trad("SetInformativo")}
                        ExtendedValues={'{"ID_BinderCompagnia": ' + Data.ID_Binder + ', "ID_TipoProdotto": ' + Data.ID_TipoProdotto + '}'}
                        SpecialInformationEnabled={false}
                        SaveURL="/api/Document/SaveBinderProductFile"
                        GetListURL={`/api/Document/GetBinderProductFile?id_BinderCompagnia=${Data.ID_Binder}&ID_TipoProdotto=${Data.ID_TipoProdotto}`}
                        AddEnabled={Editable}
                    />
                </div>

                <div className="col-lg-12">
                    <label>{Trad.Trad("ListaApprovazioniRichieste")}</label>
                    <Tipo
                        Dati={ApprovalList}
                        Campo={`Dato.Extra[${index}].ListaApprovazioniRichiesteJSON`}
                        ID_ChiaveString={Data.ListaApprovazioniRichiesteJSON}
                        OnAggiorna={OnChange}
                        Disabilitato={isProductDisabled}
                        TradValori
                        SceltaMultipla
                    />
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/Binder/BinderProduct.tsx